<div id="box">
  <div (scroll)="onScrollEvent($event)" class="app-theme" style="background: white;" [ngClass]="theme">
    <!-- <div [dir]="isRtl" > -->


    <mat-sidenav-container style="background: white;">
      <mat-sidenav #sidenav [(opened)]="calsoftService.sidenavOpen" class="sidebar-area" mode="over">
        <mat-nav-list>
          <calsoft-side-bar-menu [data]="finalData" [sideMenuItem]="categoryArray"></calsoft-side-bar-menu>
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content *ngIf="!calsoftService.sidenavOpen">
        <!-- <noscript><iframe [src]="iframeUrl | safe: 'resourceUrl'"
        height="0" width="0" style="display:none;visibility:hidden">
      </iframe></noscript> -->
        <div [ngClass]="{'calsoft-vertical-navigation-overlay':calsoftService.sidenavOpen}">

          <div *ngIf="type !== 'six' && type!=='twentyfour' && type !== 'five' && type !=='seven' && type !=='eight' && type !=='nine' && type !=='ten'
           && type !=='twelve' && type !=='thirteen' && type !=='fifteen' && type !=='sixteen' && type !=='twenty'">

           <div *ngIf="finalData.headerEnabled" class="promo-top w-100 h-auto text-center theme-container">
            <div class="copy-container">
              <div class="flex-container">
                <h4 [style.color]="finalData.headerBannerTextColour" class="font-weight-normal text-uppercase text-white m-0">
                  {{finalData.headerNotificationContent}}
                </h4> &nbsp;
                <h4 *ngIf="finalData.headerBannerCopyEnable" [style.color]="finalData.headerBannerTextColour" class="font-weight-normal text-uppercase text-white m-0">
                  {{finalData.headerBannerCopyCoupon}}
                </h4>&nbsp; &nbsp;
                <button *ngIf="finalData.headerBannerCopyEnable" (click)="copyToClipboard(finalData.headerBannerCopyCoupon)">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
          </div>
          
                
        
            <!-- <div *ngIf="finalData.headerEnabled" class="notification"
            [style.backgroundImage]="'url(' + serverPath2 + headerLogoSrc + ')'"
            onerror="this.src='assets/images/notification-back.jpg';"
            style="z-index: 1000;">
              <div *ngIf="showTopNotice" class="notify-content">
                <div fxLayout="row" fxLayoutAlign="space-between center" [style.color]="finalData.headerBannerTextColour">
                  <h3>{{ finalData.headerNotificationContent }}</h3>

                </div>
                <div fxLayout="row" fxLayoutAlign="end center">
                  <button (click)="closeTopNotice()" [style.color]="finalData.headerBannerTextColour" mat-icon-button>
                    <mat-icon style="padding-left: 50%;">close</mat-icon>
                  </button>
                </div>
              </div>
            </div> -->


          </div>


          <calsoft-header [data]="finalData" [languageSelection]="languageSelection" *ngIf="type == 'one'"
            [item]="categoryArray"> </calsoft-header>
          <HeaderTwo [data]="finalData" [languageSelection]="languageSelection" *ngIf="type == 'two' "
            [item]="categoryArray"></HeaderTwo>
          <calsoft-header-three [data]="finalData" [languageSelection]="languageSelection" *ngIf="type == 'three'"
            [item]="categoryArray"></calsoft-header-three>
          <HeaderFour [data]="finalData" [languageSelection]="languageSelection" *ngIf="type == 'four'"
            [item]="categoryArray"></HeaderFour>

            <calsoft-header-five *ngIf="type == 'five'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray">
            </calsoft-header-five>

          <calsoft-header-six [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
            *ngIf="type == 'six'"></calsoft-header-six>


          <calsoft-header-seven [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
            *ngIf="type == 'seven'"></calsoft-header-seven>

          <calsoft-header-eight [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
            *ngIf="type == 'eight'"></calsoft-header-eight>

          <calsoft-headernine [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
            *ngIf="type == 'nine'"></calsoft-headernine>

          <calsoft-header10 *ngIf="type == 'ten'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header10>

          <calsoft-header11 *ngIf="type == 'eleven'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header11>

          <calsoft-header12 *ngIf="type == 'twelve'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header12>

          <calsoft-header13 *ngIf="type == 'thirteen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header13>

          <calsoft-header14 *ngIf="type == 'fourteen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header14>

          <calsoft-header15 *ngIf="type == 'fifteen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header15>

          <calsoft-header16 *ngIf="type == 'sixteen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header16>

          <calsoft-header17 *ngIf="type == 'seventeen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray" [containerClass]="containerClass"></calsoft-header17>


          <calsoft-header18 *ngIf="type == 'eighteen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray"></calsoft-header18>

          <calsoft-header19 *ngIf="type == 'nineteen'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray">
          </calsoft-header19>

          <calsoft-header20 *ngIf="type == 'twenty'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray">

          </calsoft-header20>

          <calsoft-header21 *ngIf="type == 'twentyOne'" [data]="finalData" [languageSelection]="languageSelection"
            [item]="categoryArray">
          </calsoft-header21>

          <calsoft-header22 *ngIf="type == 'twentytwo'" [data]="finalData" [languageSelection]="languageSelection"
          [item]="categoryArray">
          </calsoft-header22>

          <calsoft-header23 *ngIf="type == 'twentythree'" [data]="finalData" [languageSelection]="languageSelection"
          [item]="categoryArray">
          </calsoft-header23>


          <calsoft-header24 *ngIf="type == 'twentyfour'" [data]="finalData" [languageSelection]="languageSelection"
          [item]="categoryArray">
          </calsoft-header24>

          <calsoft-header25 *ngIf="type == 'twentyfive'" [data]="finalData" [languageSelection]="languageSelection"
          [item]="categoryArray">
          </calsoft-header25>

          <ng-container>

            <div class="theme-container main">
              <div [ngStyle]="{'display':hideBreadcrump ? 'none' : '' }" class="container" *ngIf="!breadCrumpDisable">


                <calsoft-breadcrumb fxHide fxShow.gt-sm></calsoft-breadcrumb>
              </div>
              <div class="main12" style="margin-top: 2px;" mat-sidenav-container>
                <router-outlet></router-outlet>

              </div>
            </div>

          </ng-container>

          <div class="visiblity12" *ngIf="displayFooterOnMOb&&!defaultFooter">


            <div fxHide fxShow.gt-sm>
              &nbsp;


            </div>

          </div>

        




          <div class="margin-t10" *ngIf="!display">
            <calsoft-footer *ngIf="footerLayout == 1" [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg>

            </calsoft-footer>
            <calsoft-footer4 *ngIf="footerLayout == 5" [data]="finalData" fxHide fxShow.md fxShow.lg
              fxShow.gt-lg></calsoft-footer4>
            <calsoft-footer3 *ngIf="footerLayout == 4" [data]="finalData" fxHide fxShow.md fxShow.lg
              fxShow.gt-lg></calsoft-footer3>
            <calsoft-footer2 *ngIf="footerLayout == 3" [data]="finalData" fxHide fxShow.md fxShow.lg
              fxShow.gt-lg></calsoft-footer2>
            <calsoft-footer1 *ngIf="footerLayout == 2" [data]="finalData" fxHide fxShow.md fxShow.lg
              fxShow.gt-lg></calsoft-footer1>
            <calsoft-footer5 *ngIf="footerLayout == 6" [data]="finalData" fxHide fxShow.md fxShow.lg
              fxShow.gt-lg></calsoft-footer5>
          </div>


          <div class="margin-t10" *ngIf="display">
            <calsoft-footer *ngIf="footerLayout == 1" [data]="finalData"> </calsoft-footer>
            <calsoft-footer4 *ngIf="footerLayout == 5" [data]="finalData"></calsoft-footer4>
            <calsoft-footer3 *ngIf="footerLayout == 4" [data]="finalData"></calsoft-footer3>
            <calsoft-footer2 *ngIf="footerLayout == 3" [data]="finalData"></calsoft-footer2>
            <calsoft-footer1 *ngIf="footerLayout == 2" [data]="finalData"></calsoft-footer1>
            <calsoft-footer5 *ngIf="footerLayout == 6" [data]="finalData"></calsoft-footer5>
          </div>

          <div *ngIf="displayFooterOnMOb&&url!='/cart'
          && !url.includes('/product/')
           && url!='/checkout' && url!='/checkout/type'" fxHide fxShow.lt-lg>
            <br>
            <br>
            <br>
          </div>

          <span *ngIf="!url.includes('/product/')">
            <ng-container *ngIf="displayFooterOnMOb">
              <footer fxHide.lg fxHide.gt-lg
                *ngIf="url!='/cart' && url!='/checkout' && url!='/checkout/type'&& url!='/account/addresses'  "
                class="_fijon mat-elevation-z6 sticky mat-elevation-z7">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <div *ngFor="let item of footerMenu;let i=index" fxFlex fxLayout="column"
                    fxLayoutAlign="center center">
                    <button [color]="item.url==currentUrl?'primary':null" (click)="account(i,item.secured)"
                      [class]="item.url==currentUrl?'material-icons':'material-icons-outlined'" mat-icon-button>
                      <mat-icon class="primary-icon" *ngIf="item.url!='/cart'">{{item.icon}}</mat-icon>
                      <mat-icon class="primary-icon" *ngIf="item.url=='/cart'"
                        [matBadge]="userLoggedIn&&cartServices.cartCount!=0?cartServices.cartCount:''"
                        matBadgePosition="above after" matBadgeColor="accent">
                        shopping_cart
                      </mat-icon>
                    </button>
                    <small>{{item.name}}</small>
                  </div>

                </div>
              </footer>



            </ng-container>

          </span>

        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>

  </div>
  <!-- </div> -->
  <div *ngIf="showBackToTop" fxLayout="row" fxLayoutAlign="center center" class="tap-top top-cls primary"
    (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
  </div>

</div>